// extracted by mini-css-extract-plugin
export var active = "_3f-7";
export var container = "_3f-0";
export var evenWidth = "_3f-4";
export var large = "_3f-5";
export var outlet = "_3f-8";
export var slide = "_3f-2";
export var small = "_3f-6";
export var tab = "_3f-3";
export var tabs = "_3f-1";